
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';
import { Wait } from '@/__env/ext';
import { Oferta } from '@/__env/lib/Articulos/Articulo.lib';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;

        @Prop() public Articulo: Articulo;
        @Watch( 'Articulo', { immediate: true } )
        async onArticulo() { this.Iniciar(); }

        @Prop() public Seleccionado: boolean;
        @Watch( 'Seleccionado', { immediate: true } )
        async onSeleccionado() { this.Iniciar(); }

        async Iniciar()
        {

            if ( !this.Articulo )
                return;

            if ( !this.Seleccionado )
                return;

            this.Cargando = true;
            if ( !this.Articulo.Ofertas.hasRows() )
            {
                await Wait( 300 );
                if ( this.Controlador.EdicionPedido.Cliente.PermiteOfertas )
                {
                    await this.Articulo.CargarOfertas();
                }
            }
            this.$nextTick( () =>
            {
                this.Cargando = false;
            } );

        }

        public Cargando: boolean =false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }




    }
